import { ContextUi } from './ContextUi';
import { DevBackend } from './DevBackend';
import { InContextOptions } from './types';
import { ObserverPlugin } from './ObserverPlugin';
import { JioTranslatePlugin } from '@jiotranslate/core-beta';
export const InContextTools =
  (props?: InContextOptions): JioTranslatePlugin =>
  (jiotranslate, tools) => {
    const { credentials } = props || {};
    jiotranslate.addPlugin(DevBackend());
    if (!tools.hasUi()) {
      jiotranslate.addPlugin(ContextUi());
    }
    if (!tools.hasObserver()) {
      jiotranslate.addPlugin(ObserverPlugin());
    }
    if (credentials) {
      jiotranslate.overrideCredentials(credentials);
    }
    return jiotranslate;
  };
